module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAYAAADzoH0MAAAA/ElEQVQ4T6XUMSjGQRjH8c9LMUjZLMpkNRvIwGJjUTZlN9iUlQw2u5RFGA3KJGarSRkMymSRlOipv1xv//f9//XcdN1979vT3XO/jr+xjFGcFGuN005BfGAYO9htPFkBpWAbe9X6Jg7bSEpB8AfYwjc2cNwk6RYEf4R1fGENF/0kdYIBnGMFn4jLveolqRMEO4RLLOIdS7itk/QSBDuCa8zgDQu475b0EwQ7hhtM4xXzeCglTYJgx6vyp/CMOTz9StoIgp3EHSbwiFm8xEZbQbCrOK3ORNPt/0eQqiB1B6lXSPVBqhMHcZb5C6nfmMqDdCKlMzGdyk3xV7v/AyR2PBmeO81/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/user/jiantou.png
// module id = vHcW
// module chunks = 1